import React from "react";
import { Spinner } from "react-bootstrap";

export default function Loading(props) {
    return <div className="d-flex justify-content-center align-items-center" style={{ width: "100vw", height: "100vh" }}><Spinner animation="border" variant="primary" /></div>
}